import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import Panel from 'utils/panel';
import useDebounce from 'utils/debounce';
import useResponsive from 'utils/responsive';
import PromoBar from '../promo-bar/promo-bar';
import SearchBar from './search-bar';
import MobileMenuList from './mobile-menu-list';
import HeaderTop from '../header/header-top';
import MobileMenuBottom from './mobile-menu-bottom';

const MobileMenu = ({
  promoBar,
  navigation,
  customer,
  locales,
  logo,
  buttons,
  link,
  layout,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const debouncedIsOpen = useDebounce(isOpen, 10);
  const container = useRef(null);
  const { breakPoint } = useResponsive();

  useEffect(() => {
    const openMenu = () => setIsOpen(true);
    const hashChangeHandle = () => setIsOpen(false);
    if (
      sessionStorage.getItem('mobileMenuLanguageSelector') === 'true' &&
      layout.isBelowBreakpoint('lg')
    ) {
      window.history.replaceState(
        null,
        '',
        window.location.pathname.split('?')[0],
      );
      document.getElementById('mobile-search-overlay-toggle').click();
      setIsOpen(true);
      setTimeout(() => {
        container.current.scrollTop = container.current.scrollHeight;
      }, 300);
    }
    sessionStorage.setItem('mobileMenuLanguageSelector', false);
    document.addEventListener('openMobileMenu', openMenu);
    window.addEventListener('hashchange', hashChangeHandle);
    return () => {
      document.removeEventListener('openMobileMenu', openMenu);
      window.removeEventListener('hashchange', hashChangeHandle);
    };
  }, []);

  useEffect(() => {
    if (['tablet', 'lg'].includes(breakPoint) && isOpen) {
      setIsOpen(false);
    }
  }, [breakPoint]);

  return (
    <Panel
      additionalClasses={`bg-white overflow-hidden`}
      align="left"
      context="mobile-menu"
      onClose={() => setIsOpen(false)}
      open={isOpen}
    >
      <div className="h-full flex flex-col">
        <div className="min-h-[2.25rem] md:hidden">
          {debouncedIsOpen && (
            <PromoBar
              className="px-10 py-8 text-center md:hidden"
              slideClass="gap-y-4 gap-x-12 flex-wrap justify-center [&_.btns]:gap-12 [&_.btns]:justify-center"
              sliderProps={{
                autoHeight: true,
              }}
              {...promoBar}
            />
          )}
        </div>
        <SearchBar onClose={() => setIsOpen(false)} />
        <div
          className="flex-1 min-h-0 overflow-y-auto overscroll-none"
          ref={container}
        >
          <HeaderTop
            customer={customer}
            containerClass="border-b border-grey-300 grid grid-cols-2 [&>*]:justify-center [&>*]:border-grey-300 [&>*:first-child]:border-r [&>*]:p-8  [&>*]:min-h-[68px]"
          />
          <MobileMenuList
            navigation={navigation}
            onClose={() => setIsOpen(false)}
          />
          <MobileMenuBottom
            logo={logo}
            link={link}
            buttons={buttons}
            locales={locales}
          />
        </div>
      </div>
    </Panel>
  );
};

export default MobileMenu;
